var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOvalBorder = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "6px",
  height: "6px",
  viewBox: "0 0 6 6",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Oval-border") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "bullet-_nav---/-1",
  transform: "translate(-18.000000, -3.000000)",
  stroke: "#02339c"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-border",
  cx: 21,
  cy: 6,
  r: 2.5
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOvalBorder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Oval-border.797791e8f4187460a260e9d93ee502a1.svg";